export class GetResumeById {
  static readonly type = '[Resume] Get Resume info by Id'
  constructor(public payload: string) {}
}
